var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9838 39.1799H78.3689L78.1764 38.9873L91.6568 25.5068V25.218C80.2947 15.2039 64.5996 11.7375 50.06 16.0705C35.5203 20.4035 24.3508 31.9582 20.3066 46.5941C20.4992 46.4978 20.7881 46.4015 21.077 46.4015C26.084 43.1277 32.0539 41.2019 38.3127 41.2019C40.4311 41.2019 42.4531 41.3945 44.4752 41.7797C44.5715 41.6834 44.6678 41.6834 44.7641 41.6834C53.4301 32.1508 68.066 30.9953 78.0801 39.1799H77.9838Z",
    fill: "#EA4535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.464 46.401C102.249 38.2164 97.6272 30.8021 91.1758 25.1211L77.4064 38.7941C83.1838 43.5123 86.5539 50.6377 86.3613 58.052V60.4592C102.634 60.4592 102.634 84.724 86.3613 84.724H61.9039V103.982H61.8076L61.9039 104.174H86.3613C100.42 104.271 112.841 95.2195 116.981 81.9316C121.122 68.6438 116.018 54.2004 104.464 46.401Z",
    fill: "#557EBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9273 104.271H63.2514V84.8204H37.9273C36.0979 84.8204 34.3646 84.4353 32.7277 83.7612L18.0918 97.8194V98.012C23.8691 102.152 30.802 104.367 38.0236 104.367L37.9273 104.271Z",
    fill: "#36A852"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0839 40.7202C24.7369 40.8165 12.0267 49.6751 7.40482 62.6741C2.78295 75.7694 7.40482 90.1165 18.7669 98.5899L33.788 84.2429C25.5072 80.6802 23.5814 70.281 29.9365 64.2147C36.2915 58.0522 47.0759 59.978 50.8312 67.8737L65.8523 53.5267C59.4972 45.5347 49.5794 40.8165 39.0839 40.9128V40.7202Z",
    fill: "#F9BC15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.cb63229d31cfe9b39f6c2cdf0a77fb71.svg";
export { ForwardRef as ReactComponent };